import { wrapAssetPath } from '../../utils';

var head = function head() {
  return document.getElementsByTagName("head")[0];
};

var removeExistingFavicons = function removeExistingFavicons() {
  var h = head();
  var links = h.getElementsByTagName("link");

  for (var i = 0; i < links.length; i++) {
    if (/\bicon\b/i.test(links[i].getAttribute("rel"))) {
      h.removeChild(links[i]);
    }
  }
};

var changeFavicon = function changeFavicon(url) {
  if (typeof document !== "undefined") {
    var newLink = document.createElement("link");
    newLink.type = "image/x-icon";
    newLink.rel = "icon";
    newLink.href = url;
    removeExistingFavicons();
    head().appendChild(newLink);
  }
};

var currentTheme = "";

var setFavicon = function setFavicon(theme) {
  var name = theme.name,
      favicon = theme.favicon;

  if (currentTheme !== name) {
    currentTheme = name;
    changeFavicon(wrapAssetPath(theme, favicon));
  }
};

export default setFavicon;